export const GET_NOTIFICATIONS = 'GET_NOTIFICATIONS'
export const GET_NOTIFICATIONS_SUCCESS = 'GET_NOTIFICATIONS_SUCCESS'
export const GET_NOTIFICATIONS_ERROR = 'GET_NOTIFICATIONS_ERROR'

export const CHECK_NOTIFICATION = 'CHECK_NOTIFICATION'
export const CHECK_NOTIFICATION_SUCCESS = 'CHECK_NOTIFICATION_SUCCESS'
export const CHECK_NOTIFICATION_ERROR = 'CHECK_NOTIFICATION_ERROR'

export const CHECK_ALL_NOTIFICATIONS = 'CHECK_ALL_NOTIFICATIONS'
export const CHECK_ALL_NOTIFICATIONS_SUCCESS = 'CHECK_ALL_NOTIFICATIONS_SUCCESS'
export const CHECK_ALL_NOTIFICATIONS_ERROR = 'CHECK_ALL_NOTIFICATIONS_ERROR'

export const GET_ALL_NOTIFICATIONS = 'GET_ALL_NOTIFICATIONS'
export const GET_ALL_NOTIFICATIONS_SUCCESS = 'GET_ALL_NOTIFICATIONS_SUCCESS'
export const GET_ALL_NOTIFICATIONS_ERROR = 'GET_ALL_NOTIFICATIONS_ERROR'